var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:[
    'flex items-center justify-between p-3 rounded-xl border transition-all',
    _vm.type === 'radio' ? 'cursor-pointer' : '',
    _vm.isUnavailable
      ? 'border-gray-100 opacity-60 cursor-not-allowed bg-gray-50'
      : _vm.isSelected
      ? 'border-primary-600 bg-primary-50 ring-1 cursor-pointer'
      : _vm.isDisabled
      ? 'border-gray-100 opacity-50 cursor-not-allowed'
      : 'border-gray-200 hover:border-primary-300 hover:bg-gray-50 cursor-pointer'
  ]},[_c('div',{staticClass:"flex items-center gap-4"},[_c('div',{class:[
        _vm.type === 'radio' ? 'w-6 h-6 rounded-full' : 'w-6 h-6 rounded-lg',
        'border flex items-center justify-center transition-colors',
        _vm.isSelected
          ? 'border-primary-600 bg-primary-600 text-white'
          : 'border-gray-300 bg-white'
      ]},[(_vm.isSelected)?_c('Check',{staticStyle:{"stroke-width":"3"},attrs:{"size":14}}):_vm._e()],1),_c('span',{class:[
        'text-lg font-medium',
        _vm.isUnavailable
          ? 'text-gray-400'
          : _vm.isSelected
          ? 'text-primary-900'
          : 'text-gray-700'
      ]},[_vm._v(" "+_vm._s(_vm.modifier.name)+" "),(_vm.isUnavailable)?_c('span',{staticClass:"ml-2 text-xs uppercase bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full"},[_vm._v(" Unavailable ")]):_vm._e()])]),(_vm.modifier.price > 0)?_c('span',{staticClass:"text-gray-600 text-base font-medium"},[_vm._v(" "+_vm._s(_vm.formatPrice(_vm.modifier.price))+" ")]):_vm._e(),_c('input',{staticClass:"hidden",attrs:{"type":_vm.type,"disabled":_vm.isDisabled || _vm.isUnavailable},domProps:{"checked":_vm.isSelected},on:{"change":_vm.handleChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }